<template>
    <div>
        <div v-show="passed_filter_left">
            <designer-question-select-frame-sidepanel :fabricator="fabricator"
                                                      :door-range="doorRange"
                                                      :frame-material="frameMaterial"
                                                      v-model:target="target.left"
                                                      :frame-style-id="frame_id"
                                                      :frame-colour-external="frameColourExternal"
                                                      :frame-colour-internal="frameColourInternal"
                                                      :title="'Select Left Side Panel Style'"
                                                      :measurement.sync="measurements.left_width"
                                                      measurement-key="left_width"
                                                      measurement-label="Enter your Left Width"
                                                      :component_id="'left_side_panel_style'"
            ></designer-question-select-frame-sidepanel>

            <div v-if="passed_filter_left_comp">
                <designer-question-select-comp-options :fabricator="fabricator"
                                                       v-model:target="target.left_composite_id"
                                                       :door-range="doorRange"
                                                       :title="'Select Left Side Panel Composite Style'"
                                                       :component_id="'left_side_panel_composite_style'"
                ></designer-question-select-comp-options>

                <div v-if="passed_filter_left_comp_glass">
                    <designer-question-select-comp-glass :fabricator="fabricator"
                                                         v-model:target="target.left_composite_glass_id"
                                                         :comp-slab="target.left_composite_id"
                                                         :laminated-glass="laminatedGlass"
                                                         :title="'Select Left Side Panel Composite Glass'"
                                                         :component_id="'left_side_panel_composite_glass'"
                    ></designer-question-select-comp-glass>

                    <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                            v-model:target="target.left_composite_backing_glass_id"
                                                            :slab="target.left_composite_id"
                                                            :glass-design="target.left_composite_glass_id"
                                                               :component_id="'left_side_panel_composite_backing_glass'"
                    ></wb-designer-question-glass-backing-design>

                </div>
            </div>

            <div v-show="passed_filter_left_glass">
                <shepley-designer-question-select-side-glass
                    :type-range="doorRange"
                    :slab="slab"
                    :fabricator="fabricator"
                    v-model:target="target.left_panel_glass_id"
                    :frame-combination="frameStyle.frame_id"
                    :secured-by-design="securedByDesign"
                    :side-variant="target.left"
                    :title="'Select Left Side Panel Glass'"
                    :component_id="'left_side_panel_glass'"
                ></shepley-designer-question-select-side-glass>

                <div class="designeroption stylesoption" v-if="!mdd && [1,11,12].includes(target.left_panel_glass_id)">
                    <strong>Please Note: This is only for illustration purposes with no glass costs added to any toplight or sidescreen. No glass will be supplied by Shepley.</strong>
                </div>

                <designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                             v-model:target="target.left_panel_backing_glass_id"
                                                             :panel-glass-id="target.left_panel_glass_id"
                                                             :title="'Select Left Side Panel Backing Glass'"
                                                             :component_id="'left_side_panel_backing_glass'"
                ></designer-question-select-side-glass-obscure>
            </div>
        </div>
        <div v-show="passed_filter_right">
            <designer-question-select-frame-sidepanel :fabricator="fabricator"
                                                      :door-range="doorRange"
                                                      v-model:target="target.right"
                                                      :frame-material="frameMaterial"
                                                      :frame-style-id="frame_id"
                                                      :frame-colour-external="frameColourExternal"
                                                      :frame-colour-internal="frameColourInternal"
                                                      :title="'Select Right Side Panel Style'"
                                                      :measurement.sync="measurements.right_width"
                                                      measurement-key="right_width"
                                                      measurement-label="Enter your Right Width"
                                                      :component_id="'right_side_panel_style'"
            ></designer-question-select-frame-sidepanel>

            <div v-if="passed_filter_right_comp">
                <designer-question-select-comp-options :fabricator="fabricator"
                                                       v-model:target="target.right_composite_id"
                                                       :door-range="doorRange"
                                                       :title="'Select Right Side Panel Composite Style'"
                                                       :component_id="'right_side_panel_composite_style'"
                ></designer-question-select-comp-options>

                <div v-if="passed_filter_right_comp_glass">
                    <designer-question-select-comp-glass :fabricator="fabricator"
                                                         v-model:target="target.right_composite_glass_id"
                                                         :comp-slab="target.right_composite_id"
                                                         :laminated-glass="laminatedGlass"
                                                         :title="'Select Right Side Panel Composite Glass'"
                                                         :component_id="'right_side_panel_composite_glass'"
                    ></designer-question-select-comp-glass>

                    <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                            v-model:target="target.right_composite_backing_glass_id"
                                                            :slab="target.right_composite_id"
                                                            :glass-design="target.right_composite_glass_id"
                                                               :component_id="'right_side_panel_composite_backing_glass'"
                    ></wb-designer-question-glass-backing-design>
                </div>
            </div>

            <div v-show="passed_filter_right_glass">
                <shepley-designer-question-select-side-glass
                    :type-range="doorRange"
                    :slab="slab"
                    :fabricator="fabricator"
                    v-model:target="target.right_panel_glass_id"
                    :frame-combination="frameStyle.frame_id"
                    :secured-by-design="securedByDesign"
                    :side-variant="target.right"
                    :title="'Select Right Side Panel Glass'"
                    :component_id="'right_side_panel_glass'"
                ></shepley-designer-question-select-side-glass>

                <div class="designeroption stylesoption" v-if="!mdd && [1,11,12].includes(target.right_panel_glass_id)">
                    <strong>Please Note: This is only for illustration purposes with no glass costs added to any toplight or sidescreen. No glass will be supplied by Shepley.</strong>
                </div>

                <designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                             v-model:target="target.right_panel_backing_glass_id"
                                                             :panel-glass-id="target.right_panel_glass_id"
                                                             :title="'Select Right Side Panel Backing Glass'"
                                                             :component_id="'right_side_panel_backing_glass'"
                ></designer-question-select-side-glass-obscure>
            </div>
        </div>
        <div v-show="passed_filter_top_glass">
            <designer-question-select-frame-sidepanel-top :fabricator="fabricator"
                                                      :door-range="doorRange"
                                                      :frame-material="frameMaterial"
                                                      :frame-combination="frameStyle.frame_id"
                                                      v-model:target="target.top"
                                                      :frame-style-id="frame_id"
                                                      :frame-colour-external="frameColourExternal"
                                                      :frame-colour-internal="frameColourInternal"
                                                      :title="'Select Top Panel Style'"
                                                      :component_id="'top_panel_style'"
            ></designer-question-select-frame-sidepanel-top>

            <shepley-designer-question-select-side-glass
                :type-range="doorRange"
                :slab="slab"
                :fabricator="fabricator"
                v-model:target="target.top_panel_glass_id"
                :frame-combination="frameStyle.frame_id"
                :secured-by-design="securedByDesign"
                :side-variant="0"
                :title="'Select Top Panel Glass'"
                :component_id="'top_panel_glass'"
            ></shepley-designer-question-select-side-glass>

            <div class="designeroption stylesoption" v-if="!mdd && [1,11,12].includes(target.top_panel_glass_id)">
                <strong>Please Note: This is only for illustration purposes with no glass costs added to any toplight or sidescreen. No glass will be supplied by Shepley.</strong>
            </div>

            <designer-question-select-side-glass-obscure :fabricator="fabricator"
                                                         v-model:target="target.top_panel_backing_glass_id"
                                                         :panel-glass-id="target.top_panel_glass_id"
                                                         :title="'Select Top Panel Backing Glass'"
                                                         :component_id="'top_panel_backing_glass'"
            ></designer-question-select-side-glass-obscure>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSelectFrameSidePanels from "../DesignerQuestionSelectFrameSidePanels.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionSelectFrameSidePanels,
            TileQuestion
        ],
        props: {
            target: {
                required: true,
                coerce(val) {
                    if (typeof (val) !== 'object') {
                        return {
                            left_composite_id: 0,
                            right_composite_id: 0
                        };
                    }

                    return val;
                }
            },
            frameStyle: {
                type: Object,
                required: true,
            },
            laminatedGlass: {
                required: true,
            },
            frameMaterial: {
                required: true,
            },
            title: {
                default(){
                    return 'Select Side Panel Style';
                }
            },
            frameColourInternal: {
                required: true,
            },
            frameColourExternal: {
                required: true,
            },
            securedByDesign: {
                required: true,
            },
            mdd: {
              default(){
                return false;
              }
            },
        },
        computed: {
            passed_filter_left(){
                return this.frameMaterial === 1 && this.frameStyle.checkedPanels.indexOf("left") !== -1;
            },
            passed_filter_right(){
                return this.frameMaterial === 1 && this.frameStyle.checkedPanels.indexOf("right") !== -1;
            },
            thumbURL(){
                return '/thumb/sidepanel/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/side-panel?frame_colour_external=' + this.frameColourExternal + '&frame_colour_internal=' + this.frameColourInternal + '&framematerial=' + this.frameMaterial;
            },
            cache_key(){
                return '_' + this.fabricator;
            },
        },
        methods: {
            select_first(){
// we don't need this function so block off parent
            }
        }
    }
</script>
